module.exports = __webpack_public_path__ + "img/source0_1.0c05ced3.png";